import { wmfetch } from "@/helpers/wmfetch"; //引用fetch.js

// 查询错敏分类
export function geterrorclassify() {
  return wmfetch({
    url: '/api/violation/error/words/classify/system/list',
    method: 'get'
  })
}
// 预警内容--详情
export function getSettinginfo(data) {
  return wmfetch({
    url: '/api/alert/wx/warnning/setting/info',
    method: 'get',
    params: data
  })
}
// 预警内容--新增
export function settingadd(data) {
  return wmfetch({
    url: '/api/alert/wx/warnning/setting/add',
    method: 'post',
    data: data
  })
}